import { useEffect, useState } from 'react';
import classes from './hello-styles.module.css'
function Hello(props) {
    const [showFirst, setShowFirst] = useState(true) // change this to true
    const [showSecond, setShowSecond] = useState(true)
    let firstContent = (
        <div className={classes.text} style={{ alignSelf: 'center' }}>
            <p className={classes.begin}>let the game begin</p>
        </div>
    )
    let friendsEdition = (
        <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
            <div className={classes.soufa} />
        </div>
    )
    let whichCharacter = (
        <div className={classes.whichCharacter}>
            <div>
                Lets see which character are you!
            </div>
            <div className={classes.whichCharacterImages}>
            </div>
            <div className={classes.startButton}
                onClick={() => {
                    // setTimeout(() => {
                    props.startGameHandler()
                    // }, 500);
                }}
            >
            </div>
        </div>
    )
    useEffect(() => {
        setTimeout(() => {
            setShowFirst(false)
            setTimeout(() => {
                setShowSecond(false)
            }, 3000);
        }, 3500)
    }, [])
    return (
        <div className={classes.container}>
            {showFirst && firstContent}
            {!showFirst && showSecond && friendsEdition}
            {!showSecond && whichCharacter}
        </div>
    );
}

export default Hello;
